export default __webpack_public_path__ + "static/assets/med_gel_solid_03_b.fe4c7f0b.png";